export const TEMPLATE_KBN_BOX_WRAP: string = "00";
export const TEMPLATE_KBN_BOOK_WRAP: string = "01";
export const TEMPLATE_KBN_TRUX_BOX_WRAP: string = "02";
export const TEMPLATE_KBN_CARD_DESIGN: string = "10";
export const TEMPLATE_KBN_GIFT_MESSAGE: string = "20";
export const TEMPLATE_KBN_EGIFT_MESSAGE: string = "21";
export const TEMPLATE_KBN_QR_SETTING: string = "99";

export function isBoxWrapTemp(kbn: string | undefined):boolean{
    return TEMPLATE_KBN_BOX_WRAP === kbn;
}
export function isTruxBoxWrapTemp(kbn: string | undefined):boolean{
    return TEMPLATE_KBN_TRUX_BOX_WRAP === kbn;
}
export function isBookWrapTemp(kbn: string | undefined):boolean{
    return TEMPLATE_KBN_BOOK_WRAP === kbn;
}
export function isCardDesignTemp(kbn: string | undefined):boolean{
    return TEMPLATE_KBN_CARD_DESIGN === kbn;
}
export function isGiftMsgTemp(kbn: string | undefined):boolean{
    return TEMPLATE_KBN_GIFT_MESSAGE === kbn;
}
export function isEGiftMsgTemp(kbn: string | undefined):boolean{
    return TEMPLATE_KBN_EGIFT_MESSAGE === kbn;
}

export function isWrapTemp(kbn: string | undefined):boolean{
    return isBoxWrapTemp(kbn) || isBookWrapTemp(kbn) || isTruxBoxWrapTemp(kbn);
}

export function isMessageTemp(kbn: string | undefined):boolean{
    return isGiftMsgTemp(kbn) || isEGiftMsgTemp(kbn);
}

export function isQrSettingTemp(kbn: string | undefined):boolean{
    return TEMPLATE_KBN_QR_SETTING === kbn;
}

export const TEMPLATE_TYPE_MESSAGE: string = "TEMPLATE_TYPE_MESSAGE" as const;
export const TEMPLATE_TYPE_WRAPPING: string = "TEMPLATE_TYPE_WRAPPING" as const;
export const TEMPLATE_TYPE_CARD_DESIGN: string = "TEMPLATE_TYPE_CARD_DESIGN" as const;